import { LiksButton } from '../../components/liks/LiksButton/LiksButton';
import { useAuth } from '../../auth/useAuth';
import { useI18n } from '../../i18n/useI18n';
import './TenantDeactivatedPage.css';

export function TenantDeactivatedPage() {
  const { translate } = useI18n();
  const { logout } = useAuth();

  return (
    <div className="tenant-deactivated-page" role="alert">
      <div className="tenant-deactivated-page__content">
        <h1 className="tenant-deactivated-page__title">
          {translate('errors.tenantDeactivated.title')}
        </h1>
        <p className="tenant-deactivated-page__description">
          {translate('errors.tenantDeactivated.description')}
        </p>
        <LiksButton variant="primary" onClick={() => logout()}>
          {translate('errors.tenantDeactivated.logout')}
        </LiksButton>
      </div>
    </div>
  );
}
